import { render, staticRenderFns } from "./SplitAction.vue?vue&type=template&id=0aff2006&"
import script from "./SplitAction.vue?vue&type=script&lang=js&"
export * from "./SplitAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports